import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import RuleForm from '../inputs/RuleForm';
import InlineInputNumber from '../inputs/InlineInputNumber';
import InlineManufacturerSelect from '../inputs/InlineManufacturerSelect';
import InlineRegionSelect from '../inputs/InlineRegionSelect';


class EffectiveManufacturerPriceGuidance extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.onReset = this.onReset.bind(this);
    const { initialValues } = props;
    this.initialState = {
      percent: initialValues.percent || 0.25,
      manufacturer_ids: initialValues.manufacturer_ids || [],
      regions: initialValues.regions && initialValues.regions.length > 0 ? initialValues.regions : [0]
    };
    this.state = this.initialState;
  }

  onSubmit(event) {
    event.preventDefault();
    this.props.onSubmit({
      kind: 'effective_manufacturer_price',
      regions: _.filter(this.state.regions),
      value: {
        percent: parseFloat(this.state.percent),
        manufacturer_ids: _.map(this.state.manufacturer_ids, id_ => parseInt(id_, 10))
      }
    });
  }

  onReset() {
    this.setState(this.initialState);
  }

  render() {
    const { regions } = this.state;
    const { form, type, ...other } = this.props;

    return (
      <RuleForm
        {...other}
        onSubmit={this.onSubmit}
        onReset={this.onReset}
        isSubmitting={form.is_submitting}
      >
        <InlineRegionSelect
          onChange={val => this.setState({ regions: val })}
          value={regions}
        />
        <InlineManufacturerSelect
          value={this.state.manufacturer_ids}
          placeholder='All manufacturers by default...'
          onChange={value => this.setState({ manufacturer_ids: value })}
        />
        <InlineInputNumber
          label='Discount Percentage'
          description='Amount to discount off of each item'
          displayFormat='percent'
          value={this.state.percent}
          onChange={value => this.setState({ percent: value })}
        />
      </RuleForm>
    );
  }
}

EffectiveManufacturerPriceGuidance.defaultProps = {
  type: 'add',
  initialValues: {}
};

EffectiveManufacturerPriceGuidance.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  type: PropTypes.string,
  initialValues: PropTypes.object,
};

export default EffectiveManufacturerPriceGuidance;
